import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate } from '../public/utility'

class SupplierContactWrite extends React.Component {
    state = {}
    componentDidMount = () => {
        const { initValues基本信息 } = this.props
        this.setState({ initValues基本信息, changedValues基本信息: {} })
    }

    handlerSave = () => {
        const { changedValues基本信息, typesOfchangedValues基本信息 } = this.state
        const { onConfirm, onClose } = this.props
        onConfirm && onConfirm(changedValues基本信息, typesOfchangedValues基本信息, onClose)
    }

    handlerDelete = () => {
        const { onDelete, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () => {
            onDelete && onDelete()
            onClose && onClose()
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '姓名')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '姓名<br>Name',name:'姓名', minWidth: '95%', required: true },
            { _text: '联系电话<br>Contact number',name:'联系电话', minWidth: '95%' },
            { _text: '邮箱<br>Mailbox',name:'邮箱', minWidth: '95%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, id, bReadOnly } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => initValues基本信息.id, handler: this.handlerDelete },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(SupplierContactWrite)